// @flow

import React, { type ComponentType } from 'react';
import bemify, { toModifiers } from 'bemify-js';

import JobsCta from 'app/viewport/components/TopBar/JobsCta';
import PageSection from 'app/common/components/PageSection';
import 'app/viewport/components/TopBar/TopBar.scss';

import { type KindType } from 'app/common/types';

const bem = bemify('top-bar');

type TopBarProps = {
  ChildComponent: ComponentType<*>,
  className?: string,
  componentDispatchProps?: {},
  componentProps?: {},
  kind?: KindType,
};

const TopBar = (props: TopBarProps) => {
  const { ChildComponent } = props;
  return (
    <div className={bem(toModifiers(props.kind), props.className)}>
      <PageSection className={bem('__page-section')} kind="padded-horz">
        <ChildComponent
          {...(props.componentProps || {})}
          {...(props.componentDispatchProps || {})}
        />
      </PageSection>
    </div>
  );
};

export const TopBarJobsCta = (props: { className?: string }) => (
  <JobsCta {...props} className={bem('__jobs-cta', props.className)} />
);

export default TopBar;
